import API from "@/helpers/Api";

export default class RoleRepository extends API {


    orderByOptions= [
        { text: 'id', value: 'id', name: 'perm.id' },
        { text: 'role', value: 'role', name: 'g.id' },
        { text: 'navigation', value: 'icon', name: 'nav.navigation' },
        { text: 'permission', value: 'url', name: 'perm.permission' },
    ];

    create(data){
        const permissions = this.post('/v2/groups', data)
        return permissions;
    }
    edit(data, id){
        const permissions = this.patch('/v2/groups/'+id, data)
        return permissions;
    }
    find(id){
        const permissions = this.findOne('/v2/groups/'+id)
        return permissions;
    }
    supprimer(id){
        const permissions = this.delete('/v2/groups/'+id)
        return permissions;
    }
    search(fields, orderBy, sortOrder, itemPerPage, currentPage)
    {

        const permissions = this.listing('/v2/groups', fields, orderBy, sortOrder, itemPerPage, currentPage)
        //console.log(permissions);
        return permissions;
    }


}